module.exports = __webpack_public_path__ + "img/entrevista-etica.5596cedb.svg";